import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Users, FileCheck, ArrowRight } from 'lucide-react';
const WHATSAPP_LINK = 'https://wa.me/50689925929?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20certificaci%C3%B3n%20de%20GAS%20LP%20para%20mi%20establecimiento';
export function HowItWorks() {
  const steps = [{
    icon: MessageCircle,
    title: 'Escríbenos',
    description: 'Escríbenos a nuestro WhatsApp.'
  }, {
    icon: Users,
    title: 'Conversemos',
    description: 'Entendemos tu necesidad y te asesoramos.'
  }, {
    icon: FileCheck,
    title: 'Recibe tu certificación',
    description: 'En 48 horas o menos, garantizado. Listo para operar.'
  }];
  return <section className="py-20 bg-[#1e3a5f] text-white" data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="text-center mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-177">
            Así de fácil es certificarte
          </h2>
          <p className="text-xl text-blue-200" data-id="element-178">
            Tres pasos simples separan a tu negocio de estar 100% legal.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-179">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-blue-700/50" data-id="element-180" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center z-10" data-id="element-181">
              <div className="w-24 h-24 bg-[#1e3a5f] border-4 border-[#f59e0b] rounded-full flex items-center justify-center mb-6 shadow-xl" data-id="element-182">
                <step.icon className="w-10 h-10 text-white" data-id="element-183" />
              </div>
              <div className="absolute top-0 right-0 md:right-auto md:left-[55%] -mt-2" data-id="element-184">
                <span className="flex items-center justify-center w-8 h-8 bg-[#f59e0b] text-white font-bold rounded-full text-sm shadow-md" data-id="element-185">
                  {index + 1}
                </span>
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-186">{step.title}</h3>
              <p className="text-blue-100 max-w-xs" data-id="element-187">{step.description}</p>
            </motion.div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-188">
          <motion.a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-flex px-10 py-4 bg-[#f59e0b] hover:bg-[#d97706] text-white font-bold rounded-lg shadow-lg hover:shadow-xl transition-all text-lg items-center justify-center gap-2" data-id="element-189">
            Comenzar Ahora
            <ArrowRight className="w-5 h-5" data-id="element-190" />
          </motion.a>
        </div>
      </div>
    </section>;
}